import { render, staticRenderFns } from "./SurveyResultsModal.vue?vue&type=template&id=36a67af8&scoped=true"
import script from "./SurveyResultsModal.vue?vue&type=script&lang=js"
export * from "./SurveyResultsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a67af8",
  null
  
)

export default component.exports